// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2SAfx","item":"PaymentsMobile_item__V7stw","label":"PaymentsMobile_label__Yhp0S","amount":"PaymentsMobile_amount__1zJaB"};